import interactUserListTemplate from './interact-user-list.tpl.html';
import './interact-user-list.less';

export const interactUserListComponentModule = angular
  .module('Q.components.interact-user-list', [])

  .component('interactUserList', {
    template: interactUserListTemplate,
    bindings: {
      usersList: '<',
      type: '@',
    },
  });
